<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed && pageReady" class="p-3 flex flex-column flex-auto">
    <div>
        <div class="text-900 font-medium text-xl mb-3"><h3>Scheduled Session
        </h3></div>
        <div class="surface-card p-4 shadow-2 border-round">
            <div class="grid formgrid p-fluid">
               <p-tabView class="col-12" [style]="{'width':'100%'}" [(activeIndex)]="activeIndex">

                <p-tabPanel header="Session Details" leftIcon="pi pi-list">

                <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Session Name</label>
                    <input [(ngModel)]="ScheduledSession.name" id="classname" type="text" [ngStyle]="{'border-color': (scheduledsessionNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
                </div>
                <div *ngIf="!scheduledsessionNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Class name.</div>

                <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Session Description</label>
                    <!-- <textarea pInputText type="text" style="width:100%; height: 15vw;" [(ngModel)]="ScheduledSession.description"></textarea> -->
                    <p-editor [(ngModel)]="ScheduledSession.description" [style]="{'height':'320px'}">
                      <ng-template pTemplate="header">
                        <span class="ql-formats">
                            <p-header>
                                <span class="ql-formats">
                                  <select class="ql-size">
                                    <option value="small">Small</option>
                                    <option selected value="normal">Normal</option>
                                    <option value="large">Sub Heading</option>
                                    <option value="huge">Heading</option>
                                  </select>

                                  <select class="ql-font">
                                    <option selected value="san serif">San-Serif</option>
                                    <option value="monospace">Monospace</option>
                                    <option value="serif">Serif</option>
                                  </select>
                                </span>
                                <span class="ql-formats">
                                  <button class="ql-bold" aria-label="Bold"></button>
                                  <button class="ql-italic" aria-label="Italic"></button>
                                  <button class="ql-underline" aria-label="Underline"></button>
                                  <button class="ql-strike" aria-label="Strike"></button>
                                  <button class="ql-script" value="sub" title="Subscript"></button>
                                  <button class="ql-script" value="super" title="Superscript"></button>
                                  <button class="ql-indent" value="-1" title="Indent"></button>
                                  <button class="ql-indent" value="+1" title="Outdent"></button>
                                </span>
                                <span class="ql-formats">
                                  <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                                  </select>
                                  <span class="ql-format-separator"></span>
                                  <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                                  </select>
                              </span>
                                <span class="ql-formats">
                                  <button class="ql-list" title="Ordered" value="ordered"></button>
                                  <button class="ql-list" title="Bullet" value="bullet"></button>

                                  <select title="Text Alignment" class="ql-align" >
                                    <option label="Left"></option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                  </select>            
                                </span> 
                                <span class="ql-formats">
                                  <button aria-label="Link" class="ql-link"></button>
                                </span>
                              </p-header>
                        </span>
                    </ng-template>
                    </p-editor>
                </div>

                <div class="field mb-4 col-12">
    
                  <label for="MembershipobjFile" class="font-medium">Upload a header image for your membership. The image must be smaller than 100KB</label>
                  <div style="clear:both;width:100%">&nbsp;</div>
                  <p-fileUpload style="float:left;margin-right:10px;" mode="basic" [auto]="true" name="image" url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="100000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload File"></p-fileUpload>
                  
                  <button *ngIf="FileChosen != null && FileChosen != ''" pButton pRipple type="button" style="float: left;margin-bottom: 10px;margin-top: 1px !important;height: 50px;" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeImage()">
                    <span style="margin-right:10px;" class="pi pi-times"></span>
                    Remove Image
                  </button>
    
                  <div style="clear:both;width:100%">&nbsp;</div>

                  <div *ngIf="FileChosen != null && FileChosen != ''">
                  <p style="margin-top:10px;">This is how your image will look in place.</p>
    
                  <div class="surface-card p-4 shadow-2 border-round packageCard" style="width: 460px;">
                    <div id="image">
                        <img src="{{ FileChosen }}" style="width: 460px;margin-top: -23px;margin-left: -23px;margin-right: -23px;">
                    </div>
                    <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ScheduledSession.name}}</div>
                    <div style="padding-left: 20px; padding-right: 20px" [innerHTML]="">  
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                    </div>
    
                    <div>
                        <br><br>
                    </div>
                    <div>
                        <div>
                            <p-button label="Book this Session" icon="pi pi-check" style="width:420px;">
                            </p-button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

                <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="venueclosingstartdate">Date</label>
                    <p-calendar [selectOtherMonths]="true" [(ngModel)]="ScheduledSessionDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="venueclosingstartdate"></p-calendar>
                    <div *ngIf="!dateValid" class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Date.</div>
                </div>

                <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="venueclosingenddate">Time</label>
                    <br>
                    <p-dropdown [options]="TimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="ScheduledSessionTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                    <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                    <p-dropdown [options]="TimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="ScheduledSessionTimeMins" optionValue="code" optionLabel="name"></p-dropdown>

                </div>

                <div style="clear:both; width:100%"></div>

                <div class="field mb-4 col-12" style="max-width: 500px; margin-top:20px">
                    <label for="classname" class="font-medium">Duration (In minutes)</label>
                    <p-inputNumber id="length" [showButtons]="true" max="99999" min="1" [(ngModel)]="ScheduledSession.duration" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                </div>
                <div style="clear:both; width:100%"></div>

                <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="classname" class="font-medium">Number of places</label>
                    <p-inputNumber id="length" [showButtons]="true" max="99999" min="1" [(ngModel)]="ScheduledSession.numberofplaces" (ngModelChange)="clampMaxBookings($event)" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                </div>

                <div style="clear:both; width:100%"></div>

                <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="classname" class="font-medium">Number of weeks this runs for:</label>
                    <p-inputNumber id="length" [showButtons]="true" max="52" min="1" [(ngModel)]="ScheduledSession.numberofweeks" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                </div>

                <div style="clear:both; width:100%"></div>

                <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="maxbookings" class="font-medium">Maximum number of bookings</label>
                    <p-inputNumber inputId="maxbookings" [showButtons]="true" [max]="ScheduledSession.numberofplaces" min="0" [(ngModel)]="ScheduledSession.maxbookings" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                    <small class="block mt-1" style="color:#6c757d;">Set this to 0 for no limit, leaving the session capped only by the number of places.</small>
                </div>

                <div style="clear:both; width:100%"></div>

                <div class="field mb-4 col-12">
                  <label for="packageRule" class="font-medium">Booking Questionnaire (Questionnaire must not contain birthday questions)</label>
                  <p-dropdown [options]="BookingQuestionnaires" [(ngModel)]="ScheduledSession.questionnaire" placeholder="No Questionnaire" [showClear]="true" optionLabel="name" (onChange)="onQuestionnaireChange()"></p-dropdown>
                </div>

                 <div style="clear:both; width:100%"></div>

                <div class="field mb-4 col-12">
                    <label for="colour" class="font-medium">Colour</label>
                    <br />
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="ScheduledSession.colour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="ScheduledSession.colour" id="hexcolour" type="text" pInputText>
                </div>

                <div  class="field mb-4 col-12">
                  <label for="emailtemplate" class="font-medium">Email Template: (This template confirms the customer’s scheduled session details, usage instructions, and provides their scheduled session ID)</label>
                  <p-dropdown [options]="EmailTemplates" placeholder="Select template" [(ngModel)]="ScheduledSession.emailtemplate" optionLabel="name" [showClear]="true"></p-dropdown>
                </div>
                
                <div *ngIf="!emailTemplateValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select an email template.</div>

                <div class="col-12">
                    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="next();">
                      Next
                      <span class="pi pi-angle-right" style="margin-left:8px;"></span>
                    </button>
                </div>
                </p-tabPanel>
                <p-tabPanel header="Resources" leftIcon="pi pi-clone">
                  <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">

                    <div style="float:left; width:32%">
                      <div class="col-12 md:col-12 drag-column">
                        <span style="font-weight: bold;"> Available Resources </span>
                        <p-table [value]="availableResources">
                          <ng-template pTemplate="header">
                            <tr>
                              <th style="width: 90%;">Name</th>
                              <th>&nbsp;</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-resource>
                            <tr>
                              <td *ngIf="!resource.isresourcecontainer"><span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              <td *ngIf="resource.isresourcecontainer && !resource.isconstructed"><span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              <td *ngIf="resource.isresourcecontainer && resource.isconstructed"><span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              <td>
                                <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToResources(resource)">
                                  <span class="pi pi-angle-right"></span>
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                        <div *ngIf="availableResources.length == 0" style="padding: 15px;">
                          <i>No resources available</i>
                        </div>
                      </div>
                    </div>
                    <div style="float:left; width:65%">
                      <div class="col-12 md:col-12 drop-column" pDroppable="resources">
                        <span style="font-weight: bold;"> Selected Resources </span>
                        <p-table [value]="ScheduledSession.resources">
                          <ng-template pTemplate="header">
                            <tr>
                              <th style="width: 90%;">&nbsp;</th>
                              <th>&nbsp;</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-resource>
                            <tr>
                              <td *ngIf="!resource.isresourcecontainer"><span class="pi pi-stop" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              <td *ngIf="resource.isresourcecontainer && !resource.isconstructed"><span class="pi pi-clone" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              <td *ngIf="resource.isresourcecontainer && resource.isconstructed"><span class="pi pi-sitemap" style="margin-right: 10px;"></span>{{resource.name}}</td>
                              <td>
                                <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromResources(resource)">
                                  <span class="pi pi-angle-left"></span>
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                        <div *ngIf="ScheduledSession.resources == null || ScheduledSession.resources.length == 0" style="padding: 15px;">
                          <i>No resources selected</i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="clear:both;width:100%">&nbsp;</div>

                  <div class="col-12">
                      <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="nextRes();">
                        Next
                        <span class="pi pi-angle-right" style="margin-left:8px;"></span>
                      </button>
                      &nbsp;
                      <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      Cancel</button>
                  </div>
                </p-tabPanel>
                <p-tabPanel header="Admissions" leftIcon="pi pi-user">
                  <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">

                    <div style="float:left; width:32%">
                      <div class="col-12 md:col-12 drag-column">
                        <span style="font-weight: bold;"> Available Admissions </span>
                        <p-table [value]="availableAdmissions">
                          <ng-template pTemplate="header">
                            <tr>
                              <th style="width: 90%;">Name</th>
                              <th>&nbsp;</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-admission>
                            <tr>
                              <td><span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}}</td>
                              <td>
                                <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToAdmissions(admission)">
                                  <span class="pi pi-angle-right"></span>
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                        <div *ngIf="availableAdmissions.length == 0" style="padding: 15px;">
                          <i>No admissions available</i>
                        </div>
                      </div>
                    </div>
                    <div style="float:left; width:65%">
                      <div class="col-12 md:col-12 drop-column" pDroppable="admissions">
                        <span style="font-weight: bold;"> Selected Admissions </span>
                        <p-table [value]="ScheduledSession.membershipadmissions">
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              <th>&nbsp;</th>
                              <th>&nbsp;</th>
                              <th>&nbsp;</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-admission let-columns="columns" let-index="rowIndex">
                            <tr [pReorderableRow]="index">
                              <td>
                                <span class="pi pi-bars" pReorderableRowHandle></span>
                              </td>
                              <td>
                                <p-accordion style="background-color: white !important; margin-top: 5px; border: none;">
                                  <p-accordionTab style="background-color: white !important; margin-top: 5px; border: none;">
                                    <p-header>
                                      <div style="width:100%">
                                          <span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}} &nbsp;(Min:&nbsp;{{admission.min}},&nbsp;Max:&nbsp;{{admission.max}},&nbsp;Price:&nbsp;{{admission.price | currency:this.CurrencySymbol}})
                                      </div>
                                  </p-header>
          
                                    <div class="surface-card p-4 shadow-2 border-round">
                                      <div class="grid formgrid p-fluid">
          
                                        <div class="field mb-4 col-12">
                                          <label for="quantity" class="font-medium">Minimum</label>
                                          <p-inputNumber [(ngModel)]="admission.min" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputNumber>
                                        </div>
          
                                        <div class="field mb-4 col-12">
                                          <label for="ResourceOpt" class="font-medium">Maximum</label>
                                          <p-inputNumber [(ngModel)]="admission.max" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputNumber>
                                        </div>

                                        <div *ngIf="admission.max < admission.min" class="text-danger" Style="margin-left:10px; margin-top: -15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Max admissions must be greater ot equal to Min admissions.</div>
          
                                        <div class="field mb-4 col-12">
                                          <label for="quantity" class="font-medium">Price:</label>
                                          <p-inputNumber  [(ngModel)]="admission.price" [showButtons]="true" buttonLayout="horizontal" mode="currency" currency="{{CurrencySymbol}}"></p-inputNumber>
                                        </div>

                                          <div class="field mb-4 col-12">
                                              <label for="quantity" class="font-medium">Details Required:</label>
                                              <p-selectButton id="ppar" [options]="stateOptions" [(ngModel)]="admission.detailsrequired" ></p-selectButton>
                                          </div>
      
                                      </div>
                                    </div>
                                  </p-accordionTab>
                                </p-accordion>
                              </td>
                              <td>
                                <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromAdmissions(admission)">
                                  <span class="pi pi-angle-left"></span>
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>

                      </div>
                    </div>
                  </div>
                  <div *ngIf="!admissionsValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one admission.</div>
                  <div class="col-12">
                      <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                      <span class="pi pi-pencil" style="margin-right:8px;"></span>
                      Save Changes</button>
              `       &nbsp;
                      <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      Cancel</button>
                  </div> 
                </p-tabPanel>
                <div style="clear:both;width:100%">&nbsp;</div>
               </p-tabView>
            </div>
        </div>
    </div>
</div>